// import { GridCellProps } from '@progress/kendo-react-grid';
// import { validateNumber } from 'src/assets/static/view_checkbook/useCheckbookPeriodColumns';
// import GridCellBase from 'src/components/GridCellBase';

// const BudgetAmountPercentageDisplayCell = (props: GridCellProps) => {
//   const { dataItem, field = '' } = props;
//   const value = dataItem[field];
//   const newValue =
//     value !== '' && Number.isFinite(Number(value)) && !isNaN(Number(value))
//       ? `${(Math.round(Number(value) * 100) / 100).toFixed(2)}%`
//       : '';

//   return (
//     <GridCellBase
//       {...props}
//       title={newValue}
//       style={{
//         ...validateNumber(field, dataItem),
//         textAlign: 'left',
//       }}
//       rowSelectionEnabled
//     >
//       <span>{newValue}</span>
//     </GridCellBase>
//   );
// };

// export default BudgetAmountPercentageDisplayCell;

import { GridCellProps } from '@progress/kendo-react-grid';
import { validateNumber } from 'src/assets/static/view_checkbook/useCheckbookPeriodColumns';
import GridCellBase from 'src/components/GridCellBase';
import useDebounce from 'src/hooks/useDebounce';

const BudgetAmountPercentageDisplayCell = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;
  const debouncedNewAmount = useDebounce(dataItem.newAmount, 1000);
  const remainingBalance =
    (dataItem.card === 'add' ? +debouncedNewAmount : -debouncedNewAmount) +
    dataItem.remainingBudgetAmount;
  const remainingBudgetAmountPercentage =
    (dataItem.budgetAmount === 0 ? 0 : (remainingBalance / dataItem.budgetAmount) * 100).toFixed(
      2
    ) + '%';

  return (
    <GridCellBase
      {...props}
      title={remainingBudgetAmountPercentage + ''}
      rowSelectionEnabled
      style={{
        ...validateNumber(field, dataItem),
        textAlign: 'left',
      }}
    >
      <span>{remainingBudgetAmountPercentage}</span>
    </GridCellBase>
  );
};

export default BudgetAmountPercentageDisplayCell;
